import { useTranslation } from 'next-i18next'
import { AHyperlink, ASvg } from 'ui'
import SvgResetIcon from 'ui/svg/icons/stroke/reset.svg'
import {
  PrismicResultsBody,
  PrismicResultsItem,
  PrismicShareButton,
} from '../../prismic-types-d'
import { MShareIcon } from '../molecules/m-share-icon'

type Props = {
  quizResult: PrismicResultsBody | null
  finalAnswers: any
  shareButtons: Array<PrismicShareButton>
  onReset: () => void
}

export const CResultBottom = ({
  quizResult,
  finalAnswers,
  shareButtons,
  onReset,
}: Props) => {
  const { t } = useTranslation('common')

  const pushSegment = () => {
    if (window.analytics) {
      window.analytics.track('Quiz Retaken')
    }
  }

  const pushSegmentFaD = (item: PrismicResultsItem) => {
    if (window.analytics && item.link_subheading === 'Find A Doctor') {
      window.analytics.track('Doctor Searched')
    }
  }

  const handleResetQuiz = () => {
    pushSegment()

    if (onReset instanceof Function) {
      onReset()
    }
  }

  /* eslint-disable @next/next/no-img-element */
  return (
    <div className="flex flex-wrap px-5 md:pt-12 pb-16 bg-white lg:pt-0 md:px-24 md:bg-neutral-white">
      <div className="grid w-full grid-cols-1 md:grid-cols-2 gap-6 pb-8 text-lg font-light text-center text-neutral-white max-w-[672px]">
        {quizResult?.items.map((item) => {
          return (
            <a
              key={item.link_subheading}
              href={item.link_url.url}
              className="flex flex-col items-center pt-4"
              onClick={() => pushSegmentFaD(item)}
            >
              <img className="w-full mb-2" src={item.link_image.url} alt="" />
              <span className="block font-normal capitalize max-w-[250px] text-neutral-dark-gray">
                {item.link_heading}
              </span>
              <AHyperlink className="mt-5" type="span" color="teal" size="sm">
                <span>{item.link_subheading}</span>
              </AHyperlink>
            </a>
          )
        })}
      </div>
      <div className="flex flex-col items-center justify-between w-full mt-6 md:flex-row">
        <div className="flex items-center order-3 mt-6 md:order-1 md:mt-0">
          {!!shareButtons.length && (
            <span className="mie-4 text-p-sm font-bold uppercase text-charcoal-l">
              {t('share-quiz')}
            </span>
          )}
          {shareButtons.map((button, n) => {
            return (
              <MShareIcon
                key={n}
                className="mie-4 text-charcoal-l"
                platform={button.platform.toLowerCase()}
                message={button.message.length ? button.message[0].text : ''}
                subject={button.subject.length ? button.subject[0].text : ''}
              />
            )
          })}
        </div>
        <button
          className="inline-flex px-0 py-4 text-p-sm font-bold uppercase bg-transparent text-primary-teal md:text-charcoal-l md:order-2"
          type="button"
          onClick={handleResetQuiz}
        >
          <ASvg
            className="w-[18px] h-[18px] stroke-current mie-2"
            svg={SvgResetIcon}
          />
          {quizResult?.primary.retry_text}
        </button>
      </div>
    </div>
  )
}
